<script>
    import {pedalState, togglePedalControl, selectDeviceByIndex, selectDeviceByName} from '@app/store/pedalStore.svelte.js';
    import * as m from "@app/paraglide/messages.js";

    function toggleFootPedalControl(){
        togglePedalControl();
        // Only try to select a device if there are devices available
        if (pedalState.inputDevices.length > 0) {
            setTimeout(() => {
                selectDeviceByIndex(0);
                saveSettingsToLocalStorage();
            }, 50);
        } else {
            saveSettingsToLocalStorage();
        }
    }

    function selectFootPedalDevice(){
        console.log(pedalState.selectedInput);
        if (pedalState.selectedInput) {
            selectDeviceByName(pedalState.selectedInput.productName);
            saveSettingsToLocalStorage();
        }
    }

    function saveSettingsToLocalStorage(){
        console.log("Saving Foot Pedal Settings to Local Storage");
        localStorage.setItem("cc-device-defaults", JSON.stringify({
            enable : pedalState.enable,
            deviceName : pedalState.selectedInput ? pedalState.selectedInput.productName : "",
            functionMapping : pedalState.functionMapping
        }));
    }

    $inspect(pedalState);
    </script>
    
    <h5>{m.options_pedal_title()}</h5>
    <form id="footPedalForm" aria-label={m.options_pedal_form_label()}>
        <div class="my-4 form-check form-switch">
            <input id="footPedalEnabledCheck" type="checkbox" class="form-check-input" checked={pedalState.enable} onchange={toggleFootPedalControl} aria-labelledby="footPedalEnabledLabel">
            <label id="footPedalEnabledLabel" class="form-check-label" for="footPedalEnabledCheck">{m.options_pedal_enable()} <i class="bi bi-info-circle" title={m.options_pedal_enable_help()}></i></label>
        </div>
        
        <div class="mb-3">
            <label id="footPedalInputSelectLabel" for="footPedaliInputDeviceSelect" class="form-label">{m.options_pedal_input_device()}</label>
            <select id="footPedaliInputDeviceSelect" class="form-select" bind:value={pedalState.selectedInput} onchange={() => selectFootPedalDevice()} aria-labelledby="footPedalInputSelectLabel">
                {#each pedalState.inputDevices as inputDevice (inputDevice.productId)}
                    <option value="{inputDevice}">{inputDevice.productName}</option>
                {/each}
            </select>
        </div>
        <h5>{m.options_pedal_function_mapping_title()}</h5>
        <p class="text-muted small">{m.options_pedal_function_mapping_desc()}</p>
        <table class="table">
            <thead>
              <tr>
                <th scope="col">{m.options_pedal_value_header()}</th>
                <th scope="col">{m.options_pedal_action_header()}</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                <td>0</td>
                <td>
                    <select class="form-select" bind:value="{pedalState.functionMapping[0]}" onchange={() => saveSettingsToLocalStorage()}>
                        <option value="pause">{m.options_pedal_action_pause()}</option>
                        <option value="play">{m.options_pedal_action_play()}</option>
                        <option value="rewind">{m.options_pedal_action_rewind()}</option>
                        <option value="fastForward">{m.options_pedal_action_fast_forward()}</option>
                        <option value="none">{m.options_pedal_action_none()}</option>
                    </select>
                </td>
                </tr>
              <tr>
                <td>1</td>
                <td>
                    <select class="form-select" bind:value="{pedalState.functionMapping[1]}" onchange={() => saveSettingsToLocalStorage()}>
                        <option value="play">{m.options_pedal_action_play_pause()}</option>
                        <option value="rewind">{m.options_pedal_action_rewind()}</option>
                        <option value="fastForward">{m.options_pedal_action_fast_forward()}</option>
                        <option value="none">{m.options_pedal_action_none()}</option>
                    </select>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                    <select class="form-select" bind:value="{pedalState.functionMapping[2]}" onchange={() => saveSettingsToLocalStorage()}>
                        <option value="play">{m.options_pedal_action_play_pause()}</option>
                        <option value="rewind">{m.options_pedal_action_rewind()}</option>
                        <option value="fastForward">{m.options_pedal_action_fast_forward()}</option>
                        <option value="none">{m.options_pedal_action_none()}</option>
                    </select>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                    <select class="form-select" bind:value="{pedalState.functionMapping[3]}" onchange={() => saveSettingsToLocalStorage()}>
                        <option value="play">{m.options_pedal_action_play_pause()}</option>
                        <option value="rewind">{m.options_pedal_action_rewind()}</option>
                        <option value="fastForward">{m.options_pedal_action_fast_forward()}</option>
                        <option value="none">{m.options_pedal_action_none()}</option>
                    </select>
                </td>
              </tr> 
              <tr>
                <td>4</td>
                <td>
                    <select class="form-select" bind:value="{pedalState.functionMapping[4]}" onchange={() => saveSettingsToLocalStorage()}>
                        <option value="play">{m.options_pedal_action_play_pause()}</option>
                        <option value="rewind">{m.options_pedal_action_rewind()}</option>
                        <option value="fastForward">{m.options_pedal_action_fast_forward()}</option>
                        <option value="none">{m.options_pedal_action_none()}</option>
                    </select>
                </td>
              </tr>             
            </tbody>
          </table>
    </form>
